import { httpGet, httpPost, httpPatchMerge, httpDelete } from '../http'
import type { TEntityId } from '~/types/models'
import type { IContactRole } from '~/types/contact/models'

const apiEntityPath = '/api/companycontactroles'

export async function getCompanyContactRoles() {
  const callingMn = getCompanyContactRoles.name
  const apiPath = `${apiEntityPath}`
  return httpGet<IContactRole[]>({ callingMn, apiPath })
}

export async function createCompanyContactRole(entity: IContactRole) {
  const callingMn = createCompanyContactRole.name
  const apiPath = apiEntityPath
  return httpPost<IContactRole>({ callingMn, apiPath, entity })
}

export async function updateCompanyContactRole(
  entityData: Partial<IContactRole>,
  id: TEntityId
) {
  const callingMn = updateCompanyContactRole.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialContactRole = Partial<IContactRole>
  return httpPatchMerge<TPartialContactRole>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteCompanyContactRole(entityData: IContactRole) {
  const callingMn = deleteCompanyContactRole.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
